import React, { useEffect, useRef, useState } from 'react';
import { observeElementResize } from './observeElementResize';

/** Keep fixed-coordinate artwork and its overlays at the same scale. */
export const ScaledArtwork: React.FC<{ width: number; height: number; children: React.ReactNode }> = ({ width, height, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const measure = () => {
      const next = Math.min(1, (ref.current?.clientWidth || width) / width);
      setScale(prev => (prev === next ? prev : next));
    };
    measure();
    return observeElementResize(ref.current, measure);
  }, [width]);
  return <div ref={ref} className="game-scaled-artwork" style={{ maxWidth: width, height: height * scale }}>
    <div style={{ width, height, transform: `scale(${scale})`, transformOrigin: 'top left' }}>{children}</div>
  </div>;
};
